import de from 'svg-country-flags/png100px/de.png';
import gb from 'svg-country-flags/png100px/gb.png';
import fr from 'svg-country-flags/png100px/fr.png';

export default lang => ({ de, fr, en: gb }[lang]);
